import type { ErrorCatalogRow } from '../models/types';

export function fmtHits(n: number): string {
  if (n >= 1000) return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
  return String(n);
}

export function fmtDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function titleCase(value: string): string {
  return value ? value.charAt(0) + value.slice(1).toLowerCase() : value;
}

export function filterErrorCatalogRows(
  rows: ErrorCatalogRow[],
  search: string,
): ErrorCatalogRow[] {
  const query = search.trim().toLowerCase();
  if (!query) return rows;

  return rows.filter((row) => {
    const haystack = [
      row.errorCode,
      row.displayMessage,
      row.category,
      row.severity,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return haystack.includes(query);
  });
}
